import Timer from '../timer';
import Score from '../score';

import { getFormattedTime } from '../../../../utils';
import useAuth from '../../../../auth/useAuth';

import SoundButton from './soundButton';
import UserProfile from './userProfile';

import Logo from './images/logo.png';
import HomeIcon from './images/icon-home.svg';

import './styles.css';
import { Link } from 'react-router-dom';
import MiddleButton from './middleButton';

export default function Header({
  time = null,
  totalScore = null,
  shouldScorePlaySound = false,
  scoreLabel,
  middleButtonText,
  middleHeaderButtonClassName,
  middleHeaderButtonDataTourId,
  onMiddleButtonClick,
  middleButtonTitle,
  isMiddleButtonLoading
}) {
  const formattedTime = getFormattedTime(time);

  const { logout, isStudent } = useAuth();

  const handleLogoutClick = () => {
    logout();
  }

  return (
    <header className="game-header">
      <div className="game-header-left-part">
        <div className="game-logo">
          <Link
            to="/assignments"
            title="Assignments"
          >
            <img src={Logo} alt="Logo" />
            <span>Market Games</span>
          </Link>
        </div>
      </div>
      <div className="container">
        <div className="game-header-columns">
          {
            time !== null && 
              <Timer time={formattedTime}/>
          }
          {
            middleButtonText && onMiddleButtonClick &&
              <MiddleButton
                text={middleButtonText}
                onClick={onMiddleButtonClick}
                className={middleHeaderButtonClassName}
                title={middleButtonTitle}
                isLoading={isMiddleButtonLoading}
                dataTourId={middleHeaderButtonDataTourId}
              />
          }
          {
            totalScore !== null &&
              <Score 
                score={totalScore}
                playSound={shouldScorePlaySound}
                scoreLabel={scoreLabel}
              />
          }
        </div>
      </div>
      <div className="game-header-right-part">
        {
          isStudent() &&
            <Link
              to="#"
              title="Home"
              className="home-link"
            >
              <img src={HomeIcon} alt="Provide Feedback" />
            </Link>
        }
        <UserProfile />
        <SoundButton />
        <button className="button-logout" onClick={handleLogoutClick}>Logout</button>
      </div>
    </header>
  );
}
